import { addMinutes, format, formatDistanceToNowStrict } from "date-fns";

export function formatDate(date: Date, formatString: string = "PPp") {
  return format(date, formatString);
}

export function formatRelativeDate(date: Date) {
  return formatDistanceToNowStrict(date, {
    addSuffix: true,
    roundingMethod: "round",
  });
}

// ex: Mar 9, 2023 11:56:44 AM UTC
export function formatToUtcDate(
  date: Date,
  formatString: string = "MMM d, yyyy hh:mm:ss a"
) {
  return format(
    addMinutes(date, date.getTimezoneOffset()),
    `${formatString} 'UTC'`
  );
}
